<div class="container" id="home">

    <div class="text">
        <h1>SAVE PHOTO SAVE MEMORIES</h1>
        <button mat-raised-button color="primary" routerLink="/auth/login"> LOGIN </button>
    </div>
</div>

<div class="footer">

    <div class="image-footer">
        <figure>
            <img src="../../assets/sage.jpg" alt="">
            <br>
            <figcaption>Author & Designer</figcaption>
        </figure>
    </div>

    <div class="footer-content">
        <h3>QUICK LINKS</h3>
        <ul>
            <li> <a routerLink="/auth/login">Login</a> </li>
            <li><a routerLink="/auth/signup">Signup</a> </li>
            <li><a href="#home"> Home</a></li>
        </ul>
    </div>

</div>